import { Action, action, thunk, Thunk } from 'easy-peasy';
import { Timestamp } from 'firebase/firestore';

export interface rooms {
  roomID: string[];
}

export interface roomData {
  roomID: string;
  C_first_name: string;
  C_last_name: string;
  photo_id: string;
  c1_id: string;
  c2_id: string;
}

export interface recentChat {
  C_first_name: string;
  C_last_name: string;
  C_Id: string;
  last_msg: string;
  photo_id: string;
  roomID: string;
  seen: boolean;
  sender: boolean;
  time: Timestamp;
  c1_id: string;
  c2_id: string;
}

export interface chatData {
  message: string;
  uid: string;
  time: Timestamp;
}

export interface IChatModel {
  recentChats: recentChat[] | undefined;
  activeRoom: roomData | undefined;
  chats: chatData[] | undefined;

  setRecentChats: Action<IChatModel, recentChat[]>;
  setActiveRoom: Action<IChatModel, roomData | undefined>;
  setChats: Action<IChatModel, chatData[] | undefined>;
}

const chatModel: IChatModel = {
  recentChats: undefined,
  activeRoom: undefined,
  chats: [],

  setRecentChats: action((state, data) => {
    state.recentChats = data;
  }),
  setActiveRoom: action((state, data) => {
    state.activeRoom = data;
  }),
  setChats: action((state, data) => {
    state.chats = data;
  }),
};

export default chatModel;
